"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as e } from "react";
import t from "../components/Icon/SvgIcon.js";
const m = (o) => /* @__PURE__ */ l(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m9.282 5.966.729-.262.09-.769a1.912 1.912 0 0 1 3.796-.001l.092.771.732.26c1.256.445 2.247 1.854 2.314 3.478.028.694.102 1.411.252 2.092.436 1.97 1.645 4.24 2.546 5.756H4.165c.91-1.514 2.13-3.78 2.57-5.754.155-.7.233-1.441.264-2.156.07-1.592 1.044-2.97 2.283-3.415M12 2a3.16 3.16 0 0 1 3.139 2.786c1.816.644 3.06 2.56 3.144 4.605.027.644.095 1.284.225 1.873.415 1.88 1.657 4.164 2.566 5.666.419.69-.074 1.61-.882 1.61H3.805c-.81 0-1.303-.925-.88-1.616.92-1.5 2.17-3.78 2.59-5.66a11.3 11.3 0 0 0 .235-1.938C5.838 7.31 7.07 5.432 8.86 4.79A3.16 3.16 0 0 1 12 2.001Zm.002 18.75a2.21 2.21 0 0 1-2.21-2.21h-1.25a3.46 3.46 0 1 0 6.92 0h-1.25a2.21 2.21 0 0 1-2.21 2.21",
        clipRule: "evenodd"
      }
    )
  }
), i = e(m);
export {
  i as Bell,
  i as default
};
